/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.75.75a.75.75 0 0 0-1.5 0v1.7792a9.4422 9.4422 0 0 0-3.3368.8923l-.8887-1.5393a.75.75 0 1 0-1.299.75l.8894 1.5405a9.553 9.553 0 0 0-2.4422 2.4422l-1.5405-.8894a.75.75 0 1 0-.75 1.299l1.5393.8887a9.4422 9.4422 0 0 0-.8923 3.3368H.75a.75.75 0 0 0 0 1.5h1.7792a9.443 9.443 0 0 0 .8923 3.3368l-1.5393.8887a.75.75 0 1 0 .75 1.299l1.5405-.8894a9.5509 9.5509 0 0 0 2.4422 2.4422l-.8894 1.5405a.75.75 0 1 0 1.299.75l.8887-1.5393a9.4434 9.4434 0 0 0 3.3368.8923V23.25a.75.75 0 0 0 1.5 0v-1.7792a9.4442 9.4442 0 0 0 3.3368-.8923l.8887 1.5393a.75.75 0 0 0 1.299-.75l-.8894-1.5405a9.5486 9.5486 0 0 0 2.4422-2.4422l1.5405.8894a.75.75 0 0 0 .75-1.299l-1.5393-.8887a9.4442 9.4442 0 0 0 .8923-3.3368H23.25a.75.75 0 0 0 0-1.5h-1.7792a9.4434 9.4434 0 0 0-.8923-3.3368l1.5393-.8887a.75.75 0 0 0-.75-1.299l-1.5405.8894a9.5509 9.5509 0 0 0-2.4422-2.4422l.8894-1.5405a.75.75 0 0 0-1.299-.75l-.8887 1.5393a9.443 9.443 0 0 0-3.3368-.8923V.75Zm.6373 6.707c-2.509-.766-5.164.6467-5.9302 3.1557-.7661 2.509.6467 5.164 3.1557 5.9302 2.509.7662 5.164-.6467 5.9301-3.1557a.75.75 0 0 1 1.4347.4381c-1.0082 3.3013-4.5016 5.1603-7.8029 4.1522-3.3013-1.0081-5.1603-4.5016-4.1522-7.8028 1.0081-3.3013 4.5016-5.1603 7.8029-4.1522a.75.75 0 0 1-.4381 1.4346Zm3.643 2.0733a.75.75 0 0 0-1.0606-1.0606L12 12.4393l-1.4697-1.4696a.75.75 0 1 0-1.0606 1.0606L12 14.5607l5.0303-5.0304Z"
    clipRule="evenodd"
  />,
  'MenuExecutionFilled'
);
